import { useEffect, useState } from "react";
import { usePayment } from "../../../../APIContext/PaymentContext";
import PageTitle from "../../../../Components/Layout/UserDashLyout/PageTitle";
import Swal from "sweetalert2";
import "./savedpaymentmethod.css";

const SavedPaymentMethod = () => {
  const { loading, getPaymentMethods, removeCard } = usePayment();
  const [cards, setCards] = useState([]);
  const [isFetching, setIsFetching] = useState(true);

  // Fetch cards
  useEffect(() => {
    const fetchCards = async () => {
      setIsFetching(true);
      const data = await getPaymentMethods();
      if (data) setCards(data);
      setIsFetching(false);
    };

    fetchCards();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Handle Remove Card
  const handleRemoveCard = async (cardId) => {
    const confirmed = await Swal.fire({
      title: "Are you sure?",
      text: "This card will be removed permanently.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, remove it!",
      confirmButtonColor: "#B79527", // orange / gold
      cancelButtonColor: "#1C1C1C",
    });

    if (confirmed.isConfirmed) {
      const success = await removeCard(cardId);
      if (success) {
        setCards((prevCards) => prevCards.filter((card) => card.id !== cardId));
      }
    }
  };
  return (
    <>
      <PageTitle
        showDescription={false}
        showButton={true}
        buttonText="Add New Card"
        buttonLink="/AddNewCard"
        title="Saved Payment Methods"
      />

      <div className="saved-cards-container">
        {isFetching ? (
          <p className="loading-text black-text-clip">Loading saved cards...</p>
        ) : cards.length === 0 ? (
          <p className="empty-text black-text-clip">No saved cards found.</p>
        ) : (
          <div className="cards-grid">
            {cards.map((card) => (
              <div key={card.id} className="card-item">
                <div className="card-header">
                  <span className="card-brand black-text-clip">
                    {card.brand.toUpperCase()}
                  </span>
                  <span className="card-last4 black-text-clip text-right">
                    •••• {card.last4}
                  </span>
                </div>

                <div className="card-details">
                  <div className="card-row">
                    <label className="black-text-clip">Expiry</label>
                    <span className="black-text-clip text-right">{`${card.exp_month.toString().padStart(2, "0")}/${card.exp_year}`}</span>
                  </div>

                  <div className="card-row">
                    <label className="black-text-clip">CVC</label>
                    <span className="black-text-clip text-right">•••</span>
                  </div>

                  {card.is_default && (
                    <span className="default-badge">
                      <span className="black-text-clip">Default</span>
                    </span>
                  )}
                </div>

                <div className="card-actions">
                  <button
                    className="btn remove-btn"
                    onClick={() => handleRemoveCard(card.id)}
                  >
                    <span className="black-text-clip">Remove Card</span>
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
};

export default SavedPaymentMethod;
